module.exports = __webpack_public_path__ + "img/btnn2.aa31c07a.png";